import React from 'react';

import { useTabs } from './hooks';
import { Tabs } from 'components';
import { PageTitle } from 'modules/CommonStyles';
import { BenchmarkList } from './BenchmarkList';
import { Admin } from './Admin';
import { UploadFiles } from './UploadFiles';
import { Container, BenchmarksTitle, TimeZoneInfo } from './BenchmarksStyles';
import { GetTimeZone } from './BenchmarkList/utils';

type Props = {};

export const Benchmarks: React.FC<Props> = () => {
  const {
    activeTab,
    tabOptions,
    showAdmin,
    showUpload,
    showBenchmarks,
    setActiveTab,
  } = useTabs();

  return (
    <Container id='benchmarks'>
      <BenchmarksTitle>
        <PageTitle>Benchmark Blender</PageTitle>
      </BenchmarksTitle>
      <TimeZoneInfo data-testid='time-zone-info'>
        Time displayed in {GetTimeZone()}
      </TimeZoneInfo>
      <Tabs list={tabOptions} onChange={setActiveTab} active={activeTab} />
      {showBenchmarks && <BenchmarkList />}
      {showAdmin && <Admin />}
      {showUpload && <UploadFiles />}
    </Container>
  );
};
